import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import BuildEnvironmentBadge from '@/components/BuildEnvironmentBadge.vue';
import { useStore } from '@/stores';
export default {
  __name: 'App',
  setup(__props) {
    // import layout from '@/layout'
    const app = useStore('app');
    const getBrowserStatus = () => {
      const userAgentInfo = navigator.userAgent;
      const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod', 'HarmonyOS'];
      let flag = true;
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return !flag;
    };
    window.addEventListener('resize', () => {
      app.mobileStatus = getBrowserStatus();
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(BuildEnvironmentBadge), _createVNode(_component_router_view)], 64);
    };
  }
};